import colors, { colorNames } from '@constants/values/colors'

const kolor = {
    t: 'Kolor',
    type: 'multi-checkbox',
    name: 'kolor',
    options: colors,
    names: colorNames,
}

export default kolor